/** Ordinary public Valoria avatars; these use the existing profile and avatar loader.
 * No second activity-only avatar selection or account role is introduced. */
export const SSX_AVATAR_IDS=Object.freeze(['zoe','psymon','moby','griff','mac','kaori','elise','nate','viggo','allegra']);
export const SSX_AVATAR_HASHES=Object.freeze({
  "allegra": "56ee69f6f49911a2ce1136102face736f3c609bc8b962f160f15b1b7e27b129d",
  "elise": "9e4bd27075a82e8b945c2d45f15ef04ea5acf8ce2676f2678da12cc3fdebf9bc",
  "griff": "a3dc5d5e8dc8e0a10767cca13eac59854a0db600b019fbfefa7b2afa3fbb0cfc",
  "kaori": "7a372e868880fa4029957811018207b04c241fc96febd0d2fffd1d13873f6727",
  "mac": "ccfe2b1cf3c97a9e4c420d1cc3c4415e7da30583a5a548514ea740a0647238d0",
  "moby": "b940b19b0da4ae9c7f0415745a4ac826d6216d7dfcb11703d9da67604683e4ed",
  "nate": "82a3c99c689c0cbf6a78f08e142b1dbbffa679147587e06ecb39fa6b5c689332",
  "psymon": "27e99c3016c62dca5aff9cfed0cad6f6b94b942aba5b841a70b603d7c7d2d05f",
  "viggo": "76e1e0d5a284e38455f04bfd6e03731c984a172fbcf40020778568d4c98e38b1"
});
export const ADDITIONAL_SSX_AVATAR_MODELS=Object.freeze([
 ['psymon','Psymon'],['moby','Moby'],['griff','Griff'],['mac','Mac'],['kaori','Kaori'],['elise','Elise'],['nate','Nate'],['viggo','Viggo'],['allegra','Allegra']
].map(([value,label])=>Object.freeze({value,label,file:`valoria-${value}.glb`,revision:value+'-'+SSX_AVATAR_HASHES[value].slice(0,12)})));
